import React from "react";
import { dateFormatter } from "../../../components/tables/table";

const ProductMarcaContent = ({ marca }) => {
  if (!marca) return <></>;
  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-12">
          <h5>Nombre</h5>
          <p>{marca?.nombre}</p>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col">
          <h5>Fecha Alta</h5>
          <p>{dateFormatter(marca?.fecha_alta) + "h"}</p>
        </div>
      </div>
    </>
  );
};

export default ProductMarcaContent;
